import { ChevronLeft, ChevronRight, MoreHoriz } from "@mui/icons-material";
import { Box, styled } from "@mui/material";
import usePagination from "@mui/material/usePagination";
import { globalStyles } from "../../styles/GlobalStyles";
import { FC } from "react";

const List = styled("ul")({
  listStyle: "none",
  padding: 0,
  marginTop: 20,
  marginBottom: 20,
  display: "flex",
  justifyContent: "center",
});

const PageButton = styled("button")({
  fontSize: 15,
  borderWidth: 0,
  height: 40,
  width: 40,
  backgroundColor: "transparent",
});

const ArrowButton = styled("button")({
  borderWidth: 0,
  height: 40,
  paddingTop: 4,
  width: 40,
  backgroundColor: "#ffffff",
  borderRadius: 9,
  marginLeft: 16,
  marginRight: 16,
});

interface DynamicTablePaginationProps {
  count: number;
  onChange?: (val: number) => void;
  currentPage?: number;
}

const DynamicTablePagination: FC<DynamicTablePaginationProps> = ({
  count,
  onChange,
  currentPage = 1,
}) => {
  const { items } = usePagination({
    count: count,
    page: currentPage,
  });
  return (
    <List>
      {items.map(({ page, type, selected, onClick, ...item }) => {
        let children = null;

        if (type === "start-ellipsis" || type === "end-ellipsis") {
          children = (
            <Box height={40} width={40} sx={globalStyles.center}>
              <MoreHoriz
                fontSize="small"
                sx={{ color: "custom.foreground.secondary" }}
              />
            </Box>
          );
        } else if (type === "page") {
          children = (
            <PageButton
              style={{
                fontWeight: selected ? "bold" : undefined,
                color: selected ? "#000000" : "#595959",
                borderBottomWidth: selected ? 2 : 0,
              }}
              onClick={(e) => {
                onClick(e);
                if (typeof page === "number") {
                  onChange?.(page);
                }
              }}
              {...item}
            >
              {page}
            </PageButton>
          );
        } else {
          children = (
            <ArrowButton
              onClick={(e) => {
                onClick(e);
                if (typeof page === "number") {
                  onChange?.(page);
                }
              }}
              {...item}
            >
              {type === "previous" ? <ChevronLeft /> : <ChevronRight />}
            </ArrowButton>
          );
        }

        return <li key={`${type}-${page ?? "none"}`}>{children}</li>;
      })}
    </List>
  );
};

export default DynamicTablePagination;
